import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Logo = () => (
  <svg fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className="size-6">
    <path d="M13.8261 17.4264C16.7203 18.1174 20.2244 18.5217 24 18.5217C27.7756 18.5217 31.2797 18.1174 34.1739 17.4264C36.9144 16.7722 39.9967 15.2331 41.3563 14.1648L24.8486 40.6391C24.4571 41.267 23.5429 41.267 23.1514 40.6391L6.64374 14.1648C8.00331 15.2331 11.0856 16.7722 13.8261 17.4264Z" fill="currentColor"></path>
    <path clipRule="evenodd" d="M39.998 12.236C39.9944 12.2537 39.9875 12.2845 39.9748 12.3294C39.9436 12.4399 39.8949 12.5741 39.8346 12.7175C39.8168 12.7597 39.7989 12.8007 39.7813 12.8398C38.5103 13.7113 35.9788 14.9393 33.7095 15.4811C30.9875 16.131 27.6413 16.5217 24 16.5217C20.3587 16.5217 17.0125 16.131 14.2905 15.4811C12.0012 14.9346 9.44505 13.6897 8.18538 12.8168C8.17384 12.7925 8.16216 12.767 8.15052 12.7408C8.09919 12.6249 8.05721 12.5114 8.02977 12.411C8.00356 12.3152 8.00039 12.2667 8 12.236C8.00039 12.2054 8.00356 12.1569 8.02977 12.0611C8.05721 11.9607 8.09919 11.8472 8.15052 11.7313C8.16216 11.7051 8.17384 11.6796 8.18538 11.6553C9.44505 10.7824 12.0012 9.53751 14.2905 8.991C17.0125 8.34111 20.3587 7.95044 24 7.95044C27.6413 7.95044 30.9875 8.34111 33.7095 8.991C35.9788 9.53282 38.5103 10.7608 39.7813 11.6323C39.7989 11.6714 39.8168 11.7124 39.8346 11.7546C39.8949 11.898 39.9436 12.0322 39.9748 12.1427C39.9875 12.1876 39.9944 12.2184 39.998 12.236Z" fill="currentColor" fillRule="evenodd"></path>
  </svg>
);

const Header = ({ variant = 'dark' }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Close menu when navigating
  const handleMobileNav = (path) => {
    setIsMobileMenuOpen(false);
    if (path.startsWith('mailto:')) {
      window.location.href = path;
    } else {
      navigate(path);
    }
  };

  if (variant === 'landing') {
    return (
      <header className="w-full max-w-[1200px] mx-auto px-6 py-10 flex items-center justify-between relative z-[100]">
        <Link to="/" className="flex items-center gap-2">
          <div className="text-white">
            <Logo />
          </div>
          <span className="text-lg font-bold tracking-tight text-white">Projekto</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          <Link to="/track" className="text-white/60 text-xs font-medium uppercase tracking-widest hover:text-white transition-colors">Track</Link>
          <Link to="/faq" className="text-white/60 text-xs font-medium uppercase tracking-widest hover:text-white transition-colors">FAQ</Link>
          <a href="mailto:projecktocare@gmail.com" className="text-white/60 text-xs font-medium uppercase tracking-widest hover:text-white transition-colors">Contact</a>
          <button
            onClick={() => navigate('/start')}
            className="bg-white text-black px-6 py-2 rounded-sm text-sm font-bold tracking-tight hover:bg-gray-200 transition-colors"
          >
            Get Started
          </button>
        </nav>

        {/* Mobile Hamburger Toggle */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="material-symbols-outlined text-3xl">
            {isMobileMenuOpen ? 'close' : 'menu'}
          </span>
        </button>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div className="fixed inset-0 min-h-screen bg-black/95 z-[200] flex flex-col p-8 md:hidden overflow-hidden">
            <div className="flex justify-between items-center mb-16">
              <div className="flex items-center gap-2">
                <Logo />
                <span className="text-lg font-bold">Projekto</span>
              </div>
              <button onClick={() => setIsMobileMenuOpen(false)} className="text-white p-2">
                <span className="material-symbols-outlined text-3xl">close</span>
              </button>
            </div>

            <nav className="flex flex-col gap-8">
              <button
                onClick={() => handleMobileNav('/')}
                className="text-4xl font-bold text-left hover:text-blue-400 transition-colors"
              >
                Home
              </button>
              <button
                onClick={() => handleMobileNav('/faq')}
                className="text-4xl font-bold text-left hover:text-blue-400 transition-colors"
              >
                FAQ
              </button>
              <button
                onClick={() => handleMobileNav('/track')}
                className="text-4xl font-bold text-left hover:text-blue-400 transition-colors"
              >
                Track Status
              </button>
              <button
                onClick={() => handleMobileNav('mailto:projecktocare@gmail.com')}
                className="text-4xl font-bold text-left hover:text-blue-400 transition-colors"
              >
                Contact
              </button>
              <button
                onClick={() => handleMobileNav('/start')}
                className="mt-8 bg-white text-black text-center py-5 rounded-sm text-lg font-bold uppercase tracking-wider active:scale-95 transition-all"
              >
                Start Project
              </button>
            </nav>

            <div className="mt-auto border-t border-white/10 pt-8 text-gray-500 text-sm">
              &copy; 2026 Projekto. All rights reserved.
            </div>
          </div>
        )}
      </header>
    );
  }

  if (variant === 'light') {
    return (
      <header className="w-full flex justify-center border-b border-[#e7edf3] dark:border-slate-800 bg-white dark:bg-background-dark/50 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-[960px] w-full px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="text-primary">
              <Logo />
            </div>
            <h2 className="text-[#0e141b] dark:text-white text-lg font-bold leading-tight tracking-[-0.015em]">DevService</h2>
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            <button className="text-[#0e141b] dark:text-slate-300 text-sm font-medium hover:text-primary transition-colors" onClick={() => { }}>Process</button>
            <button className="text-[#0e141b] dark:text-slate-300 text-sm font-medium hover:text-primary transition-colors" onClick={() => { }}>Portfolio</button>
            <button className="text-[#0e141b] dark:text-slate-300 text-sm font-medium hover:text-primary transition-colors" onClick={() => { }}>Pricing</button>
            <button className="text-[#0e141b] dark:text-slate-300 text-sm font-medium hover:text-primary transition-colors" onClick={() => { }}>FAQ</button>
            <button className="bg-primary hover:bg-primary/90 text-white px-5 py-2 rounded-lg text-sm font-bold transition-all shadow-sm">
              Log In
            </button>
          </nav>
        </div>
      </header>
    );
  }

  if (variant === 'dark-form') {
    return (
      <header className="w-full flex justify-center border-b border-[#222222] bg-dark-bg sticky top-0 z-50">
        <div className="max-w-[960px] w-full px-6 md:px-10 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="text-white">
              <Logo />
            </div>
            <h2 className="text-white text-lg font-bold tracking-tight">Projekto</h2>
          </Link>
        </div>
      </header>
    );
  }

  // Success page variant
  return (
    <header className="w-full border-b border-white/10 bg-background-dark">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="text-white">
            <svg className="w-7 h-7" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.8261 17.4264C16.7203 18.1174 20.2244 18.5217 24 18.5217C27.7756 18.5217 31.2797 18.1174 34.1739 17.4264C36.9144 16.7722 39.9967 15.2331 41.3563 14.1648L24.8486 40.6391C24.4571 41.267 23.5429 41.267 23.1514 40.6391L6.64374 14.1648C8.00331 15.2331 11.0856 16.7722 13.8261 17.4264Z" fill="currentColor"></path>
            </svg>
          </div>
          <h2 className="text-white text-lg font-bold tracking-tight uppercase">DevService</h2>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <button className="text-white/60 text-xs font-medium uppercase tracking-widest hover:text-white transition-colors" onClick={() => { }}>Home</button>
          <button className="text-white/60 text-xs font-medium uppercase tracking-widest hover:text-white transition-colors" onClick={() => { }}>Projects</button>
          <button className="text-white/60 text-xs font-medium uppercase tracking-widest hover:text-white transition-colors" onClick={() => { }}>About</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
